
export const SET_LOADER = 'SET_LOADER';

// provider / user
export const SET_USER = 'SET_USER';
